/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './requestPhoneVerification.defs.js'
export { main as default } from './requestPhoneVerification.defs.js'
